import {FC, LabelHTMLAttributes } from 'react';

const Label: FC<LabelHTMLAttributes<HTMLLabelElement>> = ({children, ...rest}) => (
    <label className="font-bold text-lg text-gray-900" {...rest}>
        {children}
    </label>
);

export default Label;